import React, { useState, useEffect } from "react";
import Nav from "./Navigation";
import { useLocation } from "react-router-dom";
import { getTokenInternal } from "./useToken";
import { useNavigate } from "react-router";

const AccountSettings = () => {
  const [formData, setFormData] = useState({
    username: "",
    discord_name: "",
    role: "",
    question: "",
    answer: "",
  });

  const [token, setToken] = useState(null);
  const [oldUsername, setOldUsername] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate()
useEffect(() => {
  const fetchData = async () => {
    try {

      const fetchedToken = await getTokenInternal();
      setToken(fetchedToken);

      // Check if there's account data in the location state (sent from the "Edit" button)
      const locationState = location.state;
      if (locationState && locationState.account) {
        const { username, discord_name, role, question, answer } =
          locationState.account;
        setFormData({ username, discord_name, role, question, answer });
        setOldUsername(username); // Save the old username
      }

      setLoading(false); // Set loading to false once the data is processed

      // Redirect if token is not present or user role is not "management"
      if (
        !fetchedToken ||
        (token.account.role !== "management" && token.account.role !== "owner")
      ) {
        navigate("/");
      }
    } catch (error) {
      console.error("Error fetching token:", error);
      setLoading(false); // Set loading to false in case of an error
    }
  };

  // Fetch data when the component mounts
  fetchData();
}, [location.state, navigate]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch(`${process.env.REACT_APP_API_HOST}/api/accounts/${oldUsername}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token?.access_token}`, // Use optional chaining to prevent errors if token is null
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error updating account.");
        }
        return response.json();
      })
      .then((data) => {
        setErrorMessage("");
        navigate('/accounts')
      })
      .catch((error) => {
        console.error("Error updating account:", error);
        setErrorMessage("Error updating account. Please check your password.");
      });
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div>
      <Nav />
      <div className="max-w-md mx-auto mt-8 text-white">
        <form
          onSubmit={handleSubmit}
          className="bg-gray-800 p-6 rounded-md shadow-md"
        >
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-400"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full rounded-md bg-gray-700 text-white focus:outline-none focus:ring focus:border-blue-300"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="discord_name"
              className="block text-sm font-medium text-gray-400"
            >
              Discord Name
            </label>
            <input
              type="text"
              id="discord_name"
              name="discord_name"
              value={formData.discord_name}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full rounded-md bg-gray-700 text-white focus:outline-none focus:ring focus:border-blue-300"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="role"
              className="block text-sm font-medium text-gray-400"
            >
              Role
            </label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full rounded-md bg-gray-700 text-white focus:outline-none focus:ring focus:border-blue-300"
            >
              <option value="management">Management</option>
              <option value="helper">Helper</option>
              <option value="pleb">Pleb</option>
            </select>
          </div>

          <div className="mb-4">
            <label
              htmlFor="question"
              className="block text-sm font-medium text-gray-400"
            >
              Question
            </label>
            <input
              type="text"
              id="question"
              name="question"
              value={formData.question}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full rounded-md bg-gray-700 text-white focus:outline-none focus:ring focus:border-blue-300"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="answer"
              className="block text-sm font-medium text-gray-400"
            >
              Answer
            </label>
            <input
              type="answer"
              id="answer"
              name="answer"
              value={formData.answer}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full rounded-md bg-gray-700 text-white focus:outline-none focus:ring focus:border-blue-300"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-400"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className="mt-1 p-2 w-full rounded-md bg-gray-700 text-white focus:outline-none focus:ring focus:border-blue-300"
            />
          </div>

          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline-blue"
          >
            Update Account
          </button>

          {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}
        </form>
      </div>
    </div>
  );
};

export default AccountSettings;
